import VueRouter from 'vue-router'
import { Store } from 'vuex'
import { RootState } from './store/types'

// eslint-disable-next-line
export async function bootstrap(router: VueRouter, store: Store<RootState>) {
  store.dispatch('user/continuousRefreshToken')
}
